
import { USER_INFO, TOURIST_LOGIN } from "../apis/user.js"

export default {
  methods: {
    async loginMpByCode(code, success) {
      this.$loading(true)
      await this.$post(
        "loginByCode",
        { code },
        (resp) => {
          this.$loading(false)
          if (resp.token) {
            this.$store.commit("token", resp.token)
            if (success) return success();
            this.loadUserInfo()
          } else {
            this.$toast(this.i18n.msg_fail_login)
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(this.i18n.msg_fail_login)
          console.log(error)
        }
      )
    },
    loadUserInfo() {
      this.$loading(true)
      this.$get(
        USER_INFO,
        {},
        (resp) => {
          this.$loading(false)
          if (resp.user) {
            this.$store.commit("user", resp.user)
            this.$toast(this.i18n.msg_success_login)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user
            })
              .then(() => {
                this.loadUserInfo()
              })
              .catch(() => {
                this.$store.commit("token", null)
              })
          }
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: error
          })
            .then(() => {
              this.loadUserInfo()
            })
            .catch(() => {
              this.$store.commit("token", null)
            })
          console.log(error)
        }
      )
    },
    // 游客登录逻辑
    loginTourist(code) {
      this.$post(
        `${TOURIST_LOGIN}?code=${code}`,
        {},
        (resp) => {
          if (resp.token && this.browser !== "wechat") {
            this.$store.commit("token", resp.token)
            this.$store.commit("userType", "tourist_login")
            this.loadUserInfo()
          }
        },
        (error) => {
          console.log(error)
        }
      )
    }
  }
}
